// extracted by mini-css-extract-plugin
export default {"ad":"index_ad_UPC5N","box":"index_box_H4lrC","footer":"index_footer_Wbbeu"};